import React, {Component} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {TableCellTypes} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {inject, observer} from "mobx-react";
import {RouteComponentProps} from "react-router";
import {IUsersStore} from "../../mobx-store/storeInterfaces/usersInterface";
import {IUsersRequestsStore} from "../../mobx-store/storeInterfaces/usersRequestsInterface";


interface IProps extends RouteComponentProps {
    usersRequestsStore: IUsersRequestsStore;
}

@inject('usersRequestsStore')
@observer
class UsersRequestsScreen extends Component<IProps> {
    tableHeader: any = [];
    tableData: any[] = [];
    tableCellTypes: TableCellTypes[] = [];
    title: string;

    constructor(props: IProps) {
        super(props);
        this.title = 'Users Requests';
    }

    getAdsTableHeader = () => {
        return [
            {
                title: 'User Phone',
            },
            {
                title: 'Image',
            },
            {
                title: 'Text',
            },
        ];
    };


    getAdsTableCellTypes = (): TableCellTypes[] => {
        return [
            {
                cellType: 'Text',
                key: 'phoneNumber',
            },
            {
                cellType: 'Image',
                key: 'image',
            },
            {
                cellType: 'Text',
                key: 'text',
            },
        ];
    };

    render() {
        const {requests, loaded} = this.props.usersRequestsStore;
        this.tableHeader = this.getAdsTableHeader();
        this.tableData = requests;
        this.tableCellTypes = this.getAdsTableCellTypes();
        return loaded && (
            <div>
                <GeneralTableComponent emptyMessage='There are no requests added yet'
                                       title={this.title}
                                       tableHeader={this.tableHeader}
                                       tableData={this.tableData}
                                       tableCellTypes={this.tableCellTypes}
                                       addButton={undefined}/>
            </div>
        );
    }

    componentDidMount() {
        this.props.usersRequestsStore.getUsersRequests();
    }

}

export default UsersRequestsScreen;
